import * as React from 'react';

import ServiceWrapper from '@websky/core/src/MealService/components/ServiceWrapper/ServiceWrapper';

const Wrapper: React.FC<React.ComponentProps<typeof ServiceWrapper>> = props => {
	return <ServiceWrapper {...props} singleMealVariant="standard" />;
};

export default Wrapper;
